import { computed, watch } from "@vue/composition-api";

interface Props {
  isLoading: boolean
  isActive: boolean
  onCancel: () => void
}

interface Emits {
  "update:isActive": [value: boolean]
  opened: []
  closed: []
  update: []
}

export function useModal (props: Props, emit: Emits) {
  const isModalActive = computed({
    get: () => props.isActive,
    set: (value) => {
      if (!props.onCancel) {
        emit("update:isActive", value);
      }
    }
  });

  watch(() => props.isActive, (value) => {
    isModalActive.value = value;
    emit(value ? "opened" : "closed");
  });

  function closeModal () {
    isModalActive.value = false;
  }

  function emitUpdate () {
    emit("update");
  }

  return {
    isModalActive,
    closeModal,
    emitUpdate
  };
}